export class UserNameModel {
  public firstName = "";
  public lastName = "";
  public username = "";
}
